"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _moment = _interopRequireDefault(require("moment"));

var _uiKit = require("@devsta/ui-kit");

var _commonReact = require("@devsta/common-react");

var _getUserFullName = _interopRequireDefault(require("@devsta/get-user-full-name"));

var _utils = require("../../../common/utils");

var _PostStatus = _interopRequireDefault(require("../../../common/components/PostStatus"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

var getDate = function getDate(date) {
  return (0, _moment.default)(date).format('YYYY/MM/DD [at] hh:mm A');
};

function PostListItem(_ref) {
  var onRemovePost = _ref.onRemovePost,
      hasUpdatePermission = _ref.hasUpdatePermission;
  return function (post) {
    var inspirationId = post.inspirationId,
        title = post.title,
        description = post.description,
        updatedByUser = post.updatedByUser,
        updatedAt = post.updatedAt,
        thumbnailUrl = post.thumbnailUrl,
        assetId = post.assetId,
        status = post.status;
    return _react.default.createElement(_uiKit.List.ListItem, {
      key: inspirationId,
      className: "manage-manage-post-list-item",
      hideImage: true
    }, assetId || thumbnailUrl ? _react.default.createElement(_commonReact.AssetPreview, _extends({}, (0, _utils.buildAssetPreviewProps)({
      assetId: assetId,
      thumbnailUrl: thumbnailUrl
    }), {
      width: "100px",
      height: "100px",
      borderRadius: 6,
      hideFileTypeIcon: true
    })) : _react.default.createElement(_uiKit.Image, {
      defaultImageIcon: "guide",
      height: "100px",
      width: "100px",
      borderRadius: 6,
      defaultIconColour: "russian"
    }), _react.default.createElement(_PostStatus.default, {
      status: status
    }), _react.default.createElement("div", {
      className: "manage-post-list-item__details"
    }, _react.default.createElement("div", {
      className: "manage-post-list-item__details__right-content"
    }, _react.default.createElement("p", {
      className: "manage-post-list-item__details__title"
    }, _react.default.createElement("strong", null, title)), _react.default.createElement("p", {
      className: "manage-post-list-item__details__sub-title"
    }, description))), updatedByUser && _react.default.createElement(_uiKit.List.ListItem.UserDetails, {
      userName: (0, _getUserFullName.default)(updatedByUser),
      profileImage: updatedByUser.imageUrl
    }, _react.default.createElement("small", {
      className: "manage-post-list-item__user-role"
    }, updatedByUser.jobTitle)), _react.default.createElement("div", {
      className: "manage-post-list-item__date"
    }, _react.default.createElement("p", null, getDate(updatedAt)), _react.default.createElement("small", {
      className: "manage-post-list-item__user-role"
    }, "Last Updated")), hasUpdatePermission ? _react.default.createElement(_uiKit.Button, {
      small: true,
      type: "INVERTED",
      className: "manage-post-list-item__publish-btn",
      onClick: onRemovePost(inspirationId)
    }, "REMOVE") : null);
  };
}

var _default = PostListItem;
exports.default = _default;